import type {
  ConversationData,
  ConversationsResponse,
} from "@/features/chat/Types/conversations.ts";

import { create } from "zustand";

interface ChatStore {
  conversationList: ConversationsResponse["data"] | null;
  setConversationList: (data: ConversationsResponse["data"]) => void;
  openConversations: ConversationData[];
  setOpenConversations: (conversations: ConversationData[]) => void;
  minimizedConversations: string[];
  setMinimizedConversations: (conversationIds: string[]) => void;
  toggleMinimized: (conversationId: string) => void;
  closeConversation: (conversationId: string) => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  conversationList: null,
  setConversationList: (data: ConversationsResponse["data"]) => set({ conversationList: data }),
  openConversations: [],
  setOpenConversations: (conversations: ConversationData[]) =>
    set({ openConversations: conversations }),
  minimizedConversations: [],
  setMinimizedConversations: (conversationIds: string[]) =>
    set({ minimizedConversations: conversationIds }),
  toggleMinimized: (conversationId: string) =>
    set((state) => ({
      minimizedConversations: state.minimizedConversations.includes(conversationId)
        ? state.minimizedConversations.filter((id) => id !== conversationId)
        : [...state.minimizedConversations, conversationId],
    })),
  closeConversation: (conversationId: string) =>
    set((state) => ({
      openConversations: state.openConversations.filter((conv) => conv.id !== conversationId),
      minimizedConversations: state.minimizedConversations.filter((id) => id !== conversationId),
    })),
}));
